<template>
  <div class="home-articles row">
    <div v-if="firstArticle" class="col-lg-6 order-lg-2 mb-4 mb-lg-0">
      <router-link
        :to="{ name: 'article', params: { ...firstArticle } }"
        class="first-article"
      >
        <div class="embed-responsive">
          <img class="embed-responsive-item" :src="firstArticle.cover" />
        </div>
        <div class="content">
          <h5>{{ firstArticle.title }}</h5>
          <div
            class="short-description"
            v-html="firstArticle.short_description"
          ></div>
        </div>
      </router-link>
    </div>

    <div class="col-lg-6 order-lg-1">
      <router-link
        v-for="(article, index) in otherArticles"
        :key="index"
        :to="{ name: 'article', params: { ...article } }"
        class="row text-danger text-decoration-none"
      >
        <div class="col-lg-4 mb-3">
          <div class="embed-responsive embed-responsive-16by9">
            <img class="embed-responsive-item" :src="article.cover" />
          </div>
        </div>
        <div class="col-lg-8 mb-3">
          <h5>{{ article.title }}</h5>
          <div
            class="text-secondary short-description"
            v-html="article.short_description"
          ></div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { get } from "lodash";

export default {
  props: {
    articles: Array
  },
  computed: {
    firstArticle() {
      return get(this.articles, "0");
    },
    otherArticles() {
      return this.articles.slice(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.home-articles {
  .first-article {
    position: relative;
    display: block;

    .content {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      padding: 1rem;
      padding-top: 100px;
      color: white;
      background-image: linear-gradient(to bottom, transparent, black);

      @media screen and (max-width: 575px) {
        padding-top: 50px;
      }
    }

    .embed-responsive {
      padding-top: 75%;

      @media screen and (max-width: 575px) {
        padding-top: 100%;
      }
    }
  }

  .short-description {
    @media screen and (max-width: 767px) {
      font-size: 12px;
    }
  }
}
</style>
